/** Batch / enrollment status values aligned with backend Prisma schema usage. */

export const BATCH_STATUS_OPTIONS = [
  { value: 'Ongoing', label: 'Ongoing' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Left in between', label: 'Left in between' }
];

/** Statuses allowed when closing the source enrollment during a batch change. */
export const CLOSE_ENROLLMENT_STATUS_OPTIONS = [
  { value: 'Left in between', label: 'Left in between' },
  { value: 'Completed', label: 'Completed' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Ongoing', label: 'Ongoing' }
];
